import { Control, Errors } from 'forms/rrf';
import { Row, Col, FormGroup, FormControl } from 'react-bootstrap';
import ArrowButton from '../../common/button-arrow';

const PointRedemptionDate = ({ index, onDelete, model }) => (
  <div>
    <Row>
      <Col md={10} className="point-redemption-date-col">
        <FormGroup className="form-group">
          <Control
            model={`.${model}s[${index}]`}
            placeholder="dd/mm"
            pattern="\d\d/\d\d"
            component={FormControl}
          />
          <Errors
            show={{
              touched: true,
              focus: false
            }}
            className="errors"
            model={`.${model}s[${index}]`}
            messages={{
              patternMismatch: 'Value does not match the required pattern'
            }}
          />
          <Errors
            show={{
              touched: true,
              focus: false
            }}
            className="errors"
            model={`.${model}s[]`}
            messages={{
              [index]: 'Date is in invalid format'
            }}
          />
        </FormGroup>
      </Col>
      <Col md={2}>
        <ArrowButton
          submit={false}
          arrow={false}
          onClick={() => onDelete(index)}
        >
          Delete
        </ArrowButton>
      </Col>
    </Row>
  </div>
);

export default PointRedemptionDate;
